import { render, staticRenderFns } from "./TalentList.vue?vue&type=template&id=fa66636a&scoped=true"
import script from "./TalentList.vue?vue&type=script&lang=js"
export * from "./TalentList.vue?vue&type=script&lang=js"
import style0 from "./TalentList.vue?vue&type=style&index=0&id=fa66636a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa66636a",
  null
  
)

export default component.exports